
export const rootApiUrl = process.env.NODE_ENV === 'production' ?
  'https://zl-task-management-app.onrender.com' :
  'http://localhost:5000'